<template>
    <div>
        <v-form ref="refSeccion">
            <v-row>
                <v-col cols="12" sm="3" class="py-0">
                    <v-select v-model="dSeccionSearch.Periodo" label="Periodo" :items="dPeriodos" filled prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']"></v-select>
                </v-col>
                <v-col cols="12" sm="9" class="py-0">
                    <v-autocomplete v-model="dSeccionSearch.IdServicio" label="* Carrera Profesional"
                        :items="ssPriServiciosIngreso" item-value="IdServicio" item-text="Descripcion2"
                        :title="dSeccionSearch.IdServicio" filled prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']">
                    </v-autocomplete>
                </v-col>
            </v-row>
        </v-form>
        <v-row>
            <v-col cols="12" sm="3" class="pa-0">
                <CMatSeccionTree ref="refMatSeccionTree" @pIdSeccion="fuIdSeccion"/>
            </v-col>
            <v-col cols="12" sm="9" class="pa-0">
                <CMatSeccionMatriculaList v-if="dIdSeccion" :pIdSeccion="parseInt(dIdSeccion)" @fuSeccionSearch="fuSeccionSearch" @fuIdAlumnoChange="fuIdAlumnoChange" @fuMatriculaList="fuMatriculaList"/>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import {mapState} from 'vuex';
import CMatSeccionTree from '@/components/Academico/MatSeccionTree.vue';
import CMatSeccionMatriculaList from '@/components/Academico/MatSeccionMatriculaList.vue';
export default {
    name: 'Matricula',
    components: {CMatSeccionTree, CMatSeccionMatriculaList},
    mounted(){
        let today = new Date();
        for (var i = today.getFullYear()+1; i >= today.getFullYear()-20; i--) {
            this.dPeriodos.push(i+'-2');
            this.dPeriodos.push(i+'-1');
        }
        this.dSeccionSearch.Periodo = today.getFullYear()+'-'+(today.getMonth()<=6 ? '1' : '2');
    },
    data: () => ({
        dIdSeccion: 1,
        dPeriodos: [],
        dSeccionSearch: {
            IdServicio: '',
            Periodo: '',
        },
        dMatCargaDocente: [],
        dMatMatriculas: [],
        dMatMatriculaTable: {
            headers: [
                {value: 'IdMatricula', text: 'IdMatricula', align: ' d-none'},
                {value: 'Nro', text: 'Nro'},
                {value: 'prialumno.Alumno', text: 'Alumno'},                
                {value: 'prialumno.Codigo', text: 'Codigo'},
                {value: 'FechaMatricula', text: 'F. Matricula'},                
                {value: 'CondicionMat', text: '...'},
                {value: 'Operador', text: 'Usuario'},
            ],
            loading: false,
            search: null,
            selected: [],
        },
        dMatSeccion: {
            IdSeccion:'',
            Seccion:'',
            Turno:'',
            FechaInicio:'',
            FechaFin:'',
            Concluyo:'',
            nMatriculaCerrada:'',
            especial:'0',
            matperiodo: {
                Anio:'',
                Periodo:'',
                Nivel:'',
                IdServicio: null,
                priservicio: {
                    Iniciales:'',
                }
            }
        },
    }),
    computed: {
        ...mapState(['ssPriServiciosIngreso']),
    },
    watch: {
        'dSeccionSearch.Periodo' (val) {
            this.dSeccionSearch.IdServicio = '';
        },
        'dSeccionSearch.IdServicio' (val) {
            if (val && val !== '') {
                this.fuSeccionSearch();
            }
        },
    },
    methods: {
        fuMatriculaList(){
            this.$emit('fuMatriculaList');
        },
        fuIdSeccion(p_IdSeccion){
            if(p_IdSeccion)
                this.dIdSeccion=p_IdSeccion;
        },
        fuSeccionSearch(){
            const vArray = this.dSeccionSearch.Periodo.split("-");
            this.$refs.refMatSeccionTree.fumatperiodoByIdServicioByAnioByPeriodo(this.dSeccionSearch.IdServicio, vArray[0], vArray[1]);
        },
        fuIdAlumnoChange(p_IdAlumno) {
            this.$emit('fuIdAlumnoChange', p_IdAlumno);
        },
    }
}
</script>